var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'shop-manager-edit',
  created () {
    this.search()
  },
  data () {
    return {
      selectedUser: null,
      searchCallbackFlag: false
    }
  },
  computed: {
    shopEditManagers () {
      return this.$store.getters.shopEditManagers
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    shopEditManagerShop () {
      return this.$store.getters.shopEditManagerShop
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function() {
      this.searchCallbackFlag = false
      var data = {}
      var self = this
      var callback = function () {
        for (var i = 0; i < self.shopEditManagers.length; i++) {
          if (self.shopEditManagers[i].attributes['is-shop-master'] === 1) {
            self.selectedUser = self.shopEditManagers[i].id
            break
          }
        }
        self.searchCallbackFlag = true
      }
      this.$store.dispatch('SHOP_MANAGER_EDIT_SEARCH', { id: this.$route.params.id, data: data, callback: callback })
    },
    goBack: function () {
      this.$router.push({ path: '/shop_managers'})
    },
    onClickSave: function () {
      var self = this
      var data = { 'user_id': this.selectedUser }
      this.$store.dispatch('SHOP_MANAGER_UPDATE', { id: this.$route.params.id, data: data, callback: function (){
        self.$router.push({ path: '/shop_managers'})
      }})
    },
    /** 画像押下 */
    onClickImageModalShow: function (user) {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = user.attributes['avartar-path'] + '?token=' + this.authToken + "&timestamp=" + this.timeStamp
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    },
    onClickClear: function () {
      this.selectedUser = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-manager-edit.js